import React from "react";
import { TagDto } from "apis/data-contracts";
import { Text, View } from "@react-pdf/renderer";

export interface DocumentDetailTagsProps {
  tags?: TagDto[];
  compact?: boolean;
}

const Label = ({
  text,
  compact = false,
}: {
  text: string;
  compact?: boolean;
}) => (
  <View
    style={{
      backgroundColor: "#F3F5F9",
      padding: compact ? "1.2mm 1.8mm" : "2mm 2.5mm",
      borderRadius: compact ? "1mm" : "1.5mm",
    }}
  >
    <Text
      style={{
        fontFamily: "Pretendard",
        fontSize: compact ? "9pt" : "10pt",
      }}
    >
      {text}
    </Text>
  </View>
);

const DocumentDetailTags = ({
  tags = [],
  compact = false,
}: DocumentDetailTagsProps) => {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: compact ? "3mm" : "4mm",
      }}
    >
      <Text
        style={{
          width: compact ? "18mm" : "25mm",
          fontFamily: "Pretendard",
          fontSize: compact ? "9pt" : "10pt",
          fontWeight: 700,
        }}
      >
        태그
      </Text>
      {tags.map((tag) => (
        <Label key={tag.uuid} text={tag?.name} compact={compact} />
      ))}
    </View>
  );
};

export default DocumentDetailTags;

/* 스타일 */
// const TagContainerStyle = styled.div`
//   display: flex;
//   gap: 1rem;
//   flex-wrap: wrap;
// `;
